module.exports = __webpack_public_path__ + "media/ลี่_อันยอง.304e3801.mp3";